<template>
  <div class="bulk-edit" :style="`width: calc(100vw - ${panelWidth}px)`">
    <pageTabHeader>
      <h5>Bulk Edit</h5>
      <pageTabs @input="handleTabClick" @setTab="setTab" />
    </pageTabHeader>
    <tabContent :resetScroll="resetScroll" class="tab-content">
      <loadingTab v-if="isLoading" />
      <div v-else>
        <v-form v-model="isFormValid">
          <configTab :tab="activeTab" :isFormValid="isFormValid" />
        </v-form>
      </div>
    </tabContent>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import configTab from "@/components/bulkUpdate/config-tab/edit-config-tab";
import pageTabHeader from "@/components/page-tab-header";
import pageTabs from "@/components/client/page-tabs";
import tabContent from "@/components/tab-content";

import loadingTab from "@/components/bulkUpdate/loadingTab";

import tabData from "@/components/client/tabData";

export default {
  components: {
    configTab,
    pageTabHeader,
    pageTabs,
    tabContent,
    loadingTab,
  },
  data() {
    return {
      tab: "Profile",
      resetScroll: undefined,
      tabData,
      isFormValid: false,
    };
  },
  methods: {
    handleTabClick(tab) {
      this.$router.replace({ hash: "" });
      this.resetScroll = tab;
    },
    scrollTo(id) {
      const anchor = document.getElementById(id);
      if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
    },
    setTab(tab) {
      this.tab = tab;
    },
  },
  computed: {
    isLoading() {
      return (
        this.pendingCalls.includes("/client/template/retrieve") ||
        this.pendingCalls.includes("/client/retrieve")
      );
    },
    activeTab() {
      return tabData.find((tab) => tab.name === this.tab)["id"];
    },
    ...mapGetters({
      pendingCalls: "getPendingCallList",
      panelWidth: "getTotalPanelWidth",
    }),
  },
  mounted() {
    if (this.$route.params.tab) {
      this.tab = this.tabData.findIndex(
        (tab) => this.$route.params.tab === tab.id
      );
    }
  },
  updated() {
    if (this.$route.hash) {
      this.scrollTo(this.$route.hash.slice(1));
    }
  },
};
</script>

<style lang="scss" scoped>
.page-tab-header {
  flex-direction: column;
  padding-bottom: 0;
}
.bulk-edit {
  $subheader-height: 105px;
  height: calc(100vh - $header-height - $subheader-height);
  transition: width 200ms;
  &::v-deep {
    .config-tab {
      margin: auto;
      max-width: 920px;
    }
    .v-tab {
      text-transform: none;
    }
  }
}
.tab-content {
  height: calc(100% - 74px);
}
</style>